import { Component, input, output, signal } from '@angular/core';

import { OrderEntry } from '@boels/models';
import { OrderEntryAccessoriesGroupComponent } from '../order-entry-accessories-group/order-entry-accessories-group.component';
import { OrderEntryItemComponent } from '../order-entry-item/order-entry-item.component';
import { transition, trigger, useAnimation } from '@angular/animations';
import { heightAnimation } from '@boels/helpers';

@Component({
  selector: 'boels-order-entry',
  imports: [OrderEntryItemComponent, OrderEntryAccessoriesGroupComponent],
  templateUrl: './order-entry.component.html',
  styleUrl: './order-entry.component.scss',
  animations: [
    trigger('accessoriesListEnterAnimation', [
      transition('void => *', [
        useAnimation(heightAnimation, {
          params: { time: '300ms 200ms ease-in-out' },
        }),
      ]),
    ]),
  ],
})
export class OrderEntryComponent {
  orderEntry = input.required<OrderEntry>();
  variant = input.required<'edit' | 'readonly'>();
  accessories = input<OrderEntry[]>();
  autoFocusTarget = input<string | undefined>(undefined);
  autoFocusTargetWhenAnimationDone = signal<string | undefined>(undefined);

  mainQuantityChanged = output<number>();
  entryEditRequested = output<OrderEntry>();
  deleteOrderEntry = output<number>();

  accessoriesListAnimationDone() {
    this.autoFocusTargetWhenAnimationDone.set(this.autoFocusTarget());
  }
}
